import React from 'react'
import { FormattedMessage } from 'react-intl'

// Components
import { If } from 'src/deprecated/Conditionals'

// State
import { useListingSearchContext } from 'src/context/listingSearch'

// Assets
import Icon from './Icon'

// Styles
import styles from './Empty.module.scss'

const Empty = () => {
  const { isInEmptyState, isInNoResultsState } = useListingSearchContext()

  if (!isInEmptyState && !isInNoResultsState) return null

  return (
    <div className={styles.flex}>
      <Icon />
      <If condition={isInEmptyState}>
        <FormattedMessage
          data-qa='emptyState'
          id='Search.initialState.cta'
          defaultMessage='Search for a city or zip'
        />
      </If>
      <If condition={isInNoResultsState}>
        <div data-qa='noResultsState' className={styles.flex}>
          <FormattedMessage
            id='Search.noResults.cta1'
            defaultMessage="We can't find that place."
          />
          <FormattedMessage
            id='Search.noResults.cta2'
            defaultMessage='Search for another city or zip.'
          />
        </div>
      </If>
    </div>
  )
}

export default Empty
